'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InlineCommentEditor = require('./components/InlineCommentEditor');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InlineCommentEditor).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/ugc-editors/lib/components/inline-comment-editor/index.js
// module id = 1022
// module chunks = 4